import React from 'react';
import { MyComponentType } from '../../../component-factory/component-types';
import { ComponentIdEnum } from '../../../component-factory/ComponentIdEnum';
import { ElementConfigType } from '../../../store/type';

export const Child: MyComponentType<ElementConfigType> = () => {
  return <></>;
};

Child.definition = {
  id: ComponentIdEnum.TAB_V2_A_CHILD,
  name: 'tab子节点',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/D8AIxW3Fm11p6Of3ZinKF.png',
  config: {},
  privateSchema: {},
  category: 'hidden',
  configForm: () => <p>tab子节点</p>,
};

export default Child;
